import { Box, Card, CardMedia, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { CardComponentProps, ProjectCardComponentProps, ProjectCardListComponentProps, ProjectDashboardProps } from '../../Interface/Index'

export const CardComponent: React.FC<CardComponentProps> = ({ title, children }) => {
  return (
    <Card sx={{
      boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
      borderRadius: '8px',
      backgroundColor: '#fff',
      margin:"8px"
    }}>
      <Typography
        component="div"
        sx={{ textAlign: "left", fontSize: "18px", fontWeight: 600, color: '#151E15', p: "16px" }}
      >
        {title}
      </Typography>
      <Box className='divider' />
      <Box>
        {children}
      </Box>
    </Card>
  )
}

export const ProjectCardComponent: React.FC<ProjectCardListComponentProps> = ({ projects, stats }) => {
  return (
    <Box>
      <Box sx={{ m: 2 }}>
        <Typography sx={{ fontSize: '24px', fontWeight: 600, color: '#151E15' }}>{projects.title}</Typography>
      </Box>

      <Link to={projects.link} style={{ textDecoration: 'none' }}>
        <Card
          sx={{
            display: 'flex',
            width: '400px',
            backgroundColor: '#151E15',
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ flex: 1 }}>
            <CardMedia
              component="img"
              sx={{ height: '100%', objectFit: 'cover' }}
              image={projects.img}
              alt="Site image"
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', padding: 2, gap: 1.5, flex: 1 }}>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mt: 1 }}>
              {stats.map(({ icon, label, amount, siteName }, index) => (

                <Box
                  key={index}
                  sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#fff' }}
                >

                  <Typography sx={{ fontWeight: 600, fontSize: '18px', color: '#fff' }}>
                    {siteName}
                  </Typography>

                  <Box sx={{ width: 20, height: 20, mb: 3 }}>{icon}</Box>
                  <Box sx={{ ml: 3 }}>
                    <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>{label}</Typography>
                    <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>{amount}</Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Card>
      </Link>
    </Box>
  );
};


export const ProjectDashboardComponent: React.FC<ProjectDashboardProps> = ({ title, subTitle: SubTitle }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center',gap:1,  }}>
      <Typography sx={{ fontSize: '18px', fontWeight: 600, color: "#000", minWidth: '190px' }}>{title}
      </Typography>:
      <Typography sx={{ fontSize: '16px', fontWeight: 600, color: "#666666",minWidth: '180px' }}>{SubTitle}
      </Typography>
    </Box>
  )
}
// export const HorizontalScroller: React.FC<{ projects: ProjectCardComponentProps[] }> = ({ projects }) => {
//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         overflowX: 'auto',
//         gap: 2,
//         padding: 2,
//         scrollBehavior: 'smooth',
//       }}
//     >
//       {projects.map((project, index) => (
//         <ProjectCardComponent key={index} {...project} />
//       ))}
//     </Box>
//   );
// };

// export const ProjectCardList: React.FC<ProjectCardListComponentProps> = ({ projects }) => {
//   return (
//     <Box sx={{ overflowX: 'auto', whiteSpace: 'nowrap', padding: 2 }}>

//       <Box sx={{ display: 'flex', gap: 2 }}>
//         {projects.map((project, index) => (
//           <ProjectCardComponent
//             key={index}
//             title={project.title}
//             img={project.img}
//             siteName={project.siteName}
//             link={project.link}
//             stats={project.stats}
//           />
//         ))}
//       </Box>

//     </Box>
//   )
// }